import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import ResumePage from "../pages/resume/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/safin-resume",
    element: <ResumePage />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;
